import { render } from "./contacts.vue?vue&type=template&id=099ede3a&scoped=true"
import script from "./contacts.vue?vue&type=script&lang=js"
export * from "./contacts.vue?vue&type=script&lang=js"

import "./contacts.vue?vue&type=style&index=0&id=099ede3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-099ede3a"

export default script